/** Currency helper — Guyanese Dollar (GYD).
 * GYD is denominated in whole dollars (no cents in everyday use), so we
 * format without decimal places. Fractional values are rounded.
 */
export const CURRENCY = "G$";

export function fmt(n) {
  const num = Number(n || 0);
  return `${CURRENCY}${num.toLocaleString("en-GY", {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  })}`;
}
